import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../../helpers/axios';
import { Grid, Card, CardContent, CardHeader, IconButton, Button, Avatar, Menu, MenuItem, Typography, FormControl, OutlinedInput, TextField, CardActions, Modal, Box, Select, InputLabel, Divider, Backdrop, CircularProgress } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';
// import SMSTemplateHeader from '../sms-template/SMSTemplateHeader';
import SettingsHeader from './SettingsHeader';
import { DataGrid, GridRowParams, GridActionsCellItem, GridCellParams } from '@mui/x-data-grid';
import { EditOutlined, Add, Security as SecurityIcon, FileCopy as FileCopyIcon, KeyboardArrowLeftRounded, MoreHorizOutlined, CloseOutlined } from '@mui/icons-material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { DatePicker } from '@mui/x-date-pickers';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '65%',
    p: 4,
};

export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
        selectedHierarchies: any[];
        selectedHierarchyIds: any[];  
    };
}

export interface IState {
    pageSize: number;
    anchorEl: any;
    smsTemplateData: any[];
    filter: any;
    showTemplate: boolean;
    template: any;
    showLoader: boolean;
    group: any;
    rowInfo: any;
}

class SMSTemplate extends React.Component<RouteComponentProps<any> & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        this.state = {
            pageSize: 5,
            anchorEl: null,
            smsTemplateData: [],
            filter: '',
            showTemplate: false,
            template: '',
            showLoader: false,
            group: '',
            rowInfo: {},
        }
    }
    public componentDidMount(): void {
        // axios.get(`routes`).then(response => {
        //     this.setState({ routes: response.data.data })
        // });
        this.allSMSTemplate();
        
    }

    public allSMSTemplate(){
        this.setState({ showLoader: true });
        let data = {
            'hierarchies': this.props.user.selectedHierarchyIds,
            'limit': 10,
            'page': 1,
            'filter': this.state.filter,
            'group': this.state.group,
        }
        axios.post('allSMSTemplates', data, { headers: { 'Content-Type': 'application/json'}}).then((response: any) => {
            if(response.data.success){
                this.setState({showLoader: false});
                console.log(response.data.data);
                this.setState({smsTemplateData: response.data.data});
            } else {
                this.setState({ showLoader: false });
                toast.error(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                let errors = response.data.errors;
                for (var error in errors) {
                    toast.error(errors[error][0], {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                }
            }
        })
    }

    public updateTemplate() {
        let data = {
            'available_vars': this.state.rowInfo.variables,
            'updated_at': new Date("yyyy-mm-dd hh:mm:ss"),
            'group': this.state.group,
            'id': this.state.rowInfo.id,
            'key': this.state.rowInfo.key,
            'text': this.state.template,
            'created_at': this.state.rowInfo.created_at,
            'variables': this.state.rowInfo.variables,
        }
        axios.post('updateTemplate', data, {headers: { 'Content-Type': 'application/json'}}).then((response: any) => {
            if(response.data.success){
                this.setState({showLoader: false});
                toast.success(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                })
            } else {
                this.setState({ showLoader: false });
                toast.error(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                let errors = response.data.errors;
                for (var error in errors) {
                    toast.error(errors[error][0], {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                }
            }
            this.allSMSTemplate();
        })
    }

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;
        const open = Boolean(this.state.anchorEl);


        const columns = [
            {
                headerName: "ID",
                field: "id",
                width: 100,
              },
              {
                headerName: "Key",
                field: "key",
                width: 200,
              },
              {
                headerName: "Text",
                field: "text",
                width: 550,
              },
              {
                headerName: "Type",
                field: "type",
                width: 100,
              },
              {
                headerName: "Group",
                field: "group",
                width: 150,
              },
              {
                headerName: "Updated",
                field: "updated_at",
                width: 150,
              },
            {
                headerName: "Actions",
                field: 'actions',
                type: 'actions',
                getActions: (params: GridRowParams) => [
                    <GridActionsCellItem
                        // icon={<FileCopyIcon />}    
                        label="Edit Template"
                        onClick={() => {
                            this.setState({showTemplate: true, rowInfo: params.row, template: params.row.text})
                            // this.setState({template: this.state.rowInfo.text})
                        }}
                        showInMenu
                    />
                ]
            }
          ];
          

        return (
            <div>
                <Backdrop
                    sx={{ zIndex: (theme:any) => theme.zIndex.drawer + 1000 }}
                    open={this.state.showLoader}
                    // onClick={() => this.setState({ showLoader: false })}
                >
                    <CircularProgress className='customLoader' />
                </Backdrop>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <SettingsHeader />
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card style={{height: 600}}>
                            <CardHeader
                                title={<>
                                    <Grid container spacing={2}>
                                        <Grid item md={3} xs={12}>
                                            <Typography variant='h5' className='MuiCardHeader-title' sx={{ lineHeight: "40px" }}>{t("List of Templates")}</Typography>
                                        </Grid>

                                        <Grid item md={3} xs={12}>
                                            <FormControl fullWidth={true} size="small">
                                                <TextField
                                                    id="filter-input"
                                                    label={t("Search")}
                                                    name="filter"
                                                    value={this.state.filter}
                                                    onChange={(e: any) => this.setState({ filter: e.target.value }, () => this.allSMSTemplate())}
                                                    fullWidth={true}
                                                    size="small"
                                                />
                                            </FormControl>
                                        </Grid>
                                        
                                        <Grid item md={2} xs={12}>
                                            <FormControl fullWidth={true} size="small">
                                                <InputLabel id="route-type-label">{t("Group")}</InputLabel>
                                                <Select
                                                    labelId="route-type-label"
                                                    value={this.state.group}
                                                    onChange={(e: any) => this.setState({ group: e.target.value }, () => this.allSMSTemplate())}
                                                    displayEmpty
                                                    label={t("Status")}
                                                >
                                                    <MenuItem key={'all'} value={'all'}>{t("All")}</MenuItem>
                                                    <MenuItem key={'frontend'} value={'frontend'}>{t("Frontend")}</MenuItem>
                                                    <MenuItem key={'masteradmin'} value={'masteradmin'}>{t("Master Admin")}</MenuItem>

                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </>
                                }
                                className="text-left"
                                // action={
                                //     <CardActions>
                                //         <Button variant="contained" size="small" sx={{ outline: 'none !important' }} onClick={() => this.setState({ showAddAgent: true })}>
                                //             Delete Bags Permanently
                                //         </Button>
                                //         <Button variant="contained" size="small" sx={{ outline: 'none !important' }} onClick={() => this.setState({ showAddAgent: true })}>
                                //             Delete Bags Permanently
                                //         </Button>
                                //         <Button variant="contained" size="small" sx={{ outline: 'none !important' }} onClick={() => this.setState({ showAddAgent: true })}>
                                //             Delete Bags Permanently
                                //         </Button>
                                //     </CardActions>
                                // }
                            />

                            <CardContent>
                                <DataGrid
                                    aria-label="List of Barcoded Bags"
                                    columns={columns}
                                    rows={this.state.smsTemplateData}
                                    // pageSize={this.state.pageSize}
                                    // onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                                    // rowsPerPageOptions={[2, 5, 10, 20]}
                                    // autoHeight={true}
                                    style={{height: 500}}
                                    components={{
                                        MoreActionsIcon: EditOutlined,
                                    }}
                                    onRowClick={(params: GridRowParams) => {
                                        this.props.history.push('/customers/' + params.id)
                                    }}
                                    className="clickableList"
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Modal
                    open={this.state.showTemplate}
                    onClose={() => this.setState({ showTemplate: false })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Card>
                            <CardHeader
                                title="Details"
                                className="text-left"
                                action={
                                    <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showTemplate: false })}>
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Divider className="mb-3" />
                                <Grid container spacing={2}>
                                    <Grid item md={2} xs={12}>
                                        <Typography>Key : </Typography>
                                    </Grid>
                                    <Grid item md={10} xs={12}>
                                        <Typography>{this.state.rowInfo.key}</Typography>
                                    </Grid>
                                    <Grid item md={2} xs={12}>
                                        <Typography>Type :</Typography>
                                    </Grid>
                                    <Grid item md={10} xs={12}>
                                        <Typography>{this.state.rowInfo.type}</Typography>
                                    </Grid>
                                    <Grid item md={2} xs={12}>
                                        <Typography>Group : </Typography>
                                    </Grid>
                                    <Grid item md={10} xs={12}>
                                        <Typography>{this.state.rowInfo.group}</Typography>
                                    </Grid>
                                    <Grid item md={2} xs={12}>
                                        <Typography>Template : </Typography>
                                    </Grid>
                                    <Grid item md={10} xs={12}>
                                        {/* <TextField
                                            id="agent-email-input"
                                            label="Template"
                                            type={'text'}
                                            value={this.state.template}
                                            onChange={(e: any) => this.setState({ template: e.target.value })}
                                            defaultValue={this.state.template}
                                            fullWidth={true}
                                            multiline
                                        />*/}
                                        <TextField
                                            required
                                            id="outlined-required"
                                            label="Template"
                                            // defaultValue={this.state.template}
                                            value={this.state.template}
                                            onChange={(e: any) => this.setState({template: e.target.value})}
                                            multiline
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={2} xs={12}>
                                        <Typography>Available Variables : </Typography>
                                    </Grid>
                                    <Grid item md={10} xs={12}>
                                        <Typography></Typography>
                                    </Grid>
                                </Grid>
                                
                                <Divider className='mt-3' />
                            </CardContent>
                            <CardActions className='float-right'>
                                <Button size='small' variant='contained' className='updateButton' onClick={() => this.setState({ showTemplate: false }, () => this.updateTemplate())}>Update</Button>
                                <Button size='small' className='customCloseButton' onClick={() => this.setState({ showTemplate: false })}>Close</Button>
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>
            </div>
        )
    }
}

export default withRouter(withTranslation()(SMSTemplate))